import React, { useRef, useEffect, useState, useCallback, useMemo } from 'react';
import { Route, Switch, useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import ExperimentInfo from 'components/main/ExperimentInfo';
import {
  GetUnifiedExperimentCanvasWidth,
  DisplayModes,
  SetDisplayMode,
  GetUnifiedExperimentCanvasHeight,
  GetDisplayMode,
  isNullOrUndefined,
  showSnackBar,
  getUserToken,
  GetWellsLabels,
  GetPlatePadding,
  SetIngredients,
  showAlertSnackBar,
  isDropModeUrl,
  SetWellsLabels,
  SetCanvasLabels,
  downloadFile,
} from 'utils/Global';
import useModel from 'business/models/useModel';
import ExperimentHeader from 'components/main/ExperimentHeader';
import getExperimentInfoDetails from 'components/customComponents/Experiment/ExperimentInfo/ExperimentInfo';
import {
  getExperimentInfoIsDirty,
  getImageSchedulesIsDirty,
  getIsDirty,
  setExpInfoIsDirty,
  setIsDirty,
} from 'components/customComponents/Experiment/ImagingSchedule/ImagingScheduleData';
import BottomMenu from 'components/bottombar/BottomMenu';
import ExperimentRouteRenderer from 'components/customComponents/Renderer/ExperimentRouteRenderer';
import {
  getDefaultInspection,
  getWellAndCanvasLabels,
} from 'components/commandpanel/Navigator/DRCIPWUtil';
import { setHideAutoScores } from 'redux/actions/headerActions';
import Screen from 'components/main/Screen';
import ScoreGroupsService from 'business/services/PlateService';
import ExperimentService from 'business/services/ExperimentService';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import {
  CommandPanelsState,
  FileSystemTaskResultDTO,
  ModalDetails,
} from 'business/models/CustomModels';
import { useRMSelector } from 'redux/hooks';
import {
  callGenerateLayer,
  resetGenerateLayer,
  setExpSaved,
  setIsEditMode,
  setIsRegionImaging,
} from 'redux/reducers/experimentReducer';
import {
  selectDeletedLayers,
  selectIsDispensed,
  selectIsEditable,
  selectProductEdition,
  selectInspectionSet,
  selectShowProgress,
} from 'redux/selectors/StateSelectors';
import 'App.css';
import EIconPanels, { EReportTypes } from 'enums/EIconPanels';
import { setDeleteLayerClear } from 'redux/reducers/layerReducer';
import ECompareMode from 'enums/ECompareMode';
import {
  BooleanPropertyDTO,
  ExperimentInfoDTO,
  LayerDTO,
  SavePlateDTO,
  ScoresGroupsDTO,
  ImportIngredientsDTO,
  PrintBarcodeApiResponse,
  NavigatorMapDTO,
  ScreenRepairInfoDTO,
  AlertDTO,
  BasePropertyDTO,
} from 'business/models/Models';
import {
  clearUndoRedoStack,
  discardExperimentChanges,
  preserveExpData,
  setExperimentInfo,
  setIsFetchingExperimentData,
  setMotherPlatesScoringStatuses,
  setPlatesAtImagerStatus,
  setSelectedLayerId,
  setShouldShowLayerIngredientPanel,
  setUnselectLayer,
  setWellNavigationDetails,
} from 'redux/reducers/experimentDataReducer';
import SaveImage, {
  SaveWellDropImageParams,
} from 'components/plateviewer/well/SaveImage/SaveImage';
import { EFileExportTypes, EFileImportTypes } from 'enums/EFileExportTypes';
import { ExpDashboardContext } from './ExperimentDashboardContext';
import {
  saveAttemptedOnLyrs,
  validate,
} from 'business/plateviewer/Generate/GenerateCommon';
import { createSaveExpDTO, isPlateHaveLayer } from 'utils/ExperimentUtils';
import {
  selectExperimentLoadingProgress,
  selectIsDropImageAvailable,
  selectIsFetchingComposite,
} from 'redux/selectors/ExperimentStateSelector';
import {
  updateExperimentDataState,
  setScoreOptionsList,
} from '../../redux/reducers/experimentDataReducer';
import useExperimentHeaderPanels, {
  useExperimentHeaderPanelsProps,
} from 'components/sidePanel/experiment/hooks';
import OptimizationWizard from 'components/plateviewer/experiment/Optimization/OptimizationWizard';
import { TreeService } from 'business/services/TreeService';
import { ExperimentReportsDialogue } from 'components/reports/ExperimentReportsDialogue';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { SeedFormulation } from './Seed/SeedFormulation';
import { EProductEditions } from 'enums/EProductEditions';
import { RMLicenseHttpStatusCode } from './Licensing/RMLicenseHttpStatusCode';
import { Props as ITabPanelProps } from 'components/tab/headless/tabPanel';
import useBroadcast, { CHANNEL_ACTIONS, CHANNEL_TYPES } from 'business/broadcast';
import useImagingSchedulingValidation from 'components/customComponents/Experiment/Hooks/useImagingSchedulingValidation';
import {
  useExperimentBroadCastReceiver,
  useExperimentKeyboardHandler,
  useExperimentStates,
  useExportPOI,
  useImagedWells,
  useSetExperimentCanvasPreferences,
} from 'components/Experiment/hooks';
import ETreeNodeAccessRightNames from 'enums/ETreeNodeAccessRightNames';
import { useLicenseAuthorizeCommand } from 'CustomHooks/useLicenseAuthorizeCommand';
import { EUserAction } from 'constants/index';
import WellDashboard from 'components/well/wellDashboard';
import {
  deleteInspectionsAsync,
  fetchExperimentAsync,
  useProcessAndSetExperimentAfterSaveHandler,
} from 'redux/thunks/experiment';
import { LoadingModal, RMModal, useModalHandlers } from 'components/modal';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { RotateScreenCanvas } from 'components/Experiment/utils';
import useRMLite from 'CustomHooks/useRMLite';
import { useAwaitableModal, useShowLabelPrinterError } from 'CustomHooks';
import { preSaveRepairScreen } from './ScreenRepairModal';
import RotateCanvasModal from 'components/modal/rotateCanvasModal';
import useFrapDataPointsExport from 'CustomHooks/useFrapDataPointsExport';
import { getPlainScoreOptionsList } from 'transformers/experiment';
import { useStore } from 'react-redux';
import {
  useAllDropImageParameters,
  useAllWellNavigationDetails,
  useSelectedDropImageParameters,
  useLastSelectedWellNavigationDetails,
  useShowOverlays,
  useShowScaleBar,
  useScoreExperimentWellsInProgressCount,
} from 'redux/hooks/experiment';
import {
  DropImageParameters,
  ExperimentCanvasRoute,
  isScoringFeatureEnabled,
} from 'components/Experiment/constants';
import {
  NotificationProgressStatus,
  setNotificationMessage,
  setNotificationProgress,
  showNotification,
  setNotification,
} from 'redux/reducers/notificationReducer';
import { getNavigatorImageKeysAsString } from 'components/commandpanel/Navigator/utils';
import { useContainerFocus } from 'CustomHooks/useContainerFocus';
import connectionHubManager from 'connectionHub/connectionHubManager';
import { useSaveWellIDropImage } from 'components/plateviewer/well/WellImage/hooks';
import { showPopupBlockedModal } from 'components/reports/utils';
import { DragContextProvider } from 'components/DraggableContainer/DragContextProvider';
import { layerExplorerDefaultSelectionThunk } from 'redux/thunks/layers';
import { PropertyConstants } from 'enums/PropertyConstants';
import { ESidePanelTabs, PrintType } from './constants';
import PrintingService from 'business/services/PrintingService';

import { FmlxBanner, FmlxProgressBar } from 'fmlx-common-ui';
import { useFileNotFoundModal } from 'CustomHooks/useFileNotFoundModal';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';
import AlertBoxBody from 'components/commandpanel/ImportDoe/AlertBoxBody';
import IEventSubscription from 'generic/IEventSubscription';
import {
  useFollowCanvasWell,
  useInitialPlateZoom,
  useZoomToPlateHandler,
} from 'components/plateviewer/experiment/hooks';
import Konva from 'konva';
import { useSystemProperty } from 'CustomHooks/useSystemProperty';
let widthMainDiv = 100;
let openedSideBars = 0;
let canvasWidth;
const imageNowDetails = {};
let nodeMenuDetails;
let scoreViewRef;
let refSaveImage = null;
const updatedProperties: BasePropertyDTO[] = [];

const _experimentService = new ExperimentService();
const _gpService = new GlobalPreferencesService();
const treeService = new TreeService();
const DEFAULT_WELL_NUMBER = 1;

const DuplicateImageScheduleEntriesBody = (duplicatRows) => {
  let errorMsg = `Please remove duplicate imaging schedule entries for\n`;
  duplicatRows.forEach((item, ind) => {
    errorMsg += `${ind + 1}) Day ${item.days}, hour ${item.hours} \n`;
  });
  return errorMsg;
};

let loadingText = 'Deleting Inspection';
function ExperimentDashboard(props) {
  const { exp, dispatch } = useExperimentStates();
  const location = useLocation();
  const expInfo = getExperimentInfoDetails();
  const [expDefinationChanged, setExpDefinationChanged] = useState(true);
  const [stateUpdated, setStateUpdated] = useState(false);
  const [modalOkDisabled, setModalOkDisabled] = useState(false);
  const [fileExportActionType, setFileExportActionType] = useState(EFileExportTypes.NONE);
  const [importedIngredientCoflicts, setImportedIngredientCoflicts] =
    useState<ImportIngredientsDTO>();
  const [fileImportActionType, setFileImportActionType] = useState(EFileImportTypes.NONE);
  const [isLoading, setIsLoading] = useState(false);
  const [isExperimentLoaded, setIsExperimentLoaded] = useState<boolean>(false);
  const deletedLayers = useRMSelector(selectDeletedLayers);
  const explorerBroadcastChannel = useBroadcast(CHANNEL_TYPES.EXPLORER);
  const licenseAuthCommand = useLicenseAuthorizeCommand();
  const [startWellSlideShow, setStartWellSlideShow] = useState(false);
  const [isSlideShowInitiatedFromCanvas, setSlideShowInitiatedFromCanvas] =
    useState(false);
  const [showReportDialogue, setShowReportDialogue] = useState<boolean>(false);
  const [navigatorMap, setNavigatorMap] = useState<NavigatorMapDTO>();
  const [breadCrumbs, setBreadCrumbs] = useState([]);
  const processAndSaveExperiment = useProcessAndSetExperimentAfterSaveHandler();
  const history = useHistory();
  const expOriginal = useRMSelector((state) => state?.experiment?.originalExpData);
  const {
    showModal: showModalSimple,
    showLoadingModal,
    showAwaitableModal,
    hideModal,
  } = useModalHandlers();
  const { showModal, modalContent: awaitableModalContent } = useAwaitableModal();
  const store = useStore();
  const [popupBlockedModal, setPopupBlockedModal] = useState(false);
  const [showOverlays] = useShowOverlays();
  const [showScaleBar] = useShowScaleBar();
  const showFileNotFoundModal = useFileNotFoundModal();
  const imagedWells = useImagedWells(navigatorMap);

  if (exp?.info?.name) {
    document.title = exp?.info?.name;
  }

  const [modalDetails, setModalDetails] = useState<ModalDetails>({
    showModal: false,
    setShowModal: () => {},
    onOk: () => {},
    body: null,
    heading: '',
    isOkOnly: false,
    okButtonText: undefined,
    noButtonText: undefined,
    showButtons: true,
  });
  const [compareMode, setCompareMode] = useState(ECompareMode.Grid);

  const expid = props.match.params.id;
  const [refresh, setRefresh] = useState(false);
  const initialPanelsState: CommandPanelsState = {
    ingredientInfo: false,
    imagingSettings: false,
    layerDesign: false,
    navigator: false,
    plateInfo: false,
    requiredStock: false,
    focusLevel: false,
    imagingSchedule: false,
    proteinLayer: false,
    screenlayer: false,
    imageNow: false,
    imageTuning: false,
    lots: false,
  };
  const duplicateImagingScheduleRows = useImagingSchedulingValidation();
  const isEditMode: boolean = useRMSelector(selectIsEditable);
  const [openedIconPanel, setOpenedIconPanel] = useState('');
  const [showLayers, setShowLayers] = useState(false);
  const [drawingLayerType, setDrawingLayerType] = useState('');
  const [selectedSidePanelTab, setSelectedSidePanelTab] = useState(null);
  const canvasStageRef = useRef<Konva.Stage>(null);
  const isDropImageAvailable = useRMSelector(selectIsDropImageAvailable);
  const allWellImagingSettingDetails = useAllDropImageParameters();
  const allWellNavigationDetails = useAllWellNavigationDetails();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const { wellNum, plateID, plateNum } = wellNavigationDetails || {};
  const { cpId, dropNumber, regionName, inspection } = selectedDropImageParameters || {};
  const exportPOI = useExportPOI();
  const [panelsState, setPanelsState] = useState<CommandPanelsState>(initialPanelsState);
  const [exportFrapDataPoints, isFrap] = useFrapDataPointsExport();
  const [showRotateCanvasMessageBox, setShowRotateCanvasMessageBox] = useState<boolean>();
  const genCanvas = useCallback(() => dispatch(callGenerateLayer()), [dispatch]);
  const setExp = useCallback(
    (exp: ExperimentDtoClient) => dispatch(updateExperimentDataState(exp)),
    [dispatch],
  );
  const clearUndoStack = useCallback(() => dispatch(clearUndoRedoStack()), [dispatch]);
  const [expName, setExpName] = useState('');
  const [header, setHeader] = useState(DisplayModes.DESIGN);
  const [isLayerMode, setIsLayerMode] = useState(false);
  const [cursorClass, setCursorClass] = useState('');
  const [showOptimize, setShowOptimize] = useState(false);
  const [showSeedFormulation, setShowSeedFormulation] = useState(false);
  const [reportType, setReportType] = useState<string>('');
  const [isResourceAvailable, setIsResourceAvailable] = useState(true);
  const [selectedCanvasRoute, setSelectedCanvasRoute] =
    useState<ExperimentCanvasRoute | null>(null);
  const canvasContainerRef = useRef<HTMLDivElement | null>(null);
  const [isCanvasInFocus, setIsCanvasInFocus] = useContainerFocus(
    canvasContainerRef,
    true,
  );
  const isPasteNotAllowed = useMemo(
    () =>
      exp?.accessRightName !== ETreeNodeAccessRightNames.Modify ||
      (exp?.isDispensed && !isEditMode) ||
      exp?.screenRepairInfo?.totalLayersUsingScreen > 0,
    [isEditMode, exp?.isDispensed, exp?.screenRepairInfo?.totalLayersUsingScreen],
  );
  const productEdition = useRMSelector(selectProductEdition);
  const selectedInspectionSet = useRMSelector((state) => selectInspectionSet(state));
  const rmLite = useRMLite();
  const { saveWellDropImage } = useSaveWellIDropImage();
  useSetExperimentCanvasPreferences();
  useExperimentBroadCastReceiver(
    exp?.treeNodeId,
    setBreadCrumbs,
    setExpHeaderName,
    exp?.info,
  );
  useExperimentKeyboardHandler(
    navigatorMap,
    saveExperiment,
    zoomInvocker,
    setRefresh,
    exp?.isImageModeActive,
    isCanvasInFocus,
  );
  const wellRefs = useRef<{ [key: string]: any }>({});
  const savedZoomFunctionDelegate = useRef<((zoomIn: boolean) => void) | null>(null);
  const query = new URLSearchParams(window.location.search);
  const urlPlateMatch = window.location.pathname.match(/\/plate\/(\d+)/);
  const urlPlateId = urlPlateMatch ? Number(urlPlateMatch[1]) : null;
  const queryPlateId = parseInt(query.get('plateId')) || urlPlateId;
  const queryWellNumber = parseInt(query.get('wellNumber')) || DEFAULT_WELL_NUMBER;
  const showLabelPrinterError = useShowLabelPrinterError();
  const scoreExperimentWellsInProgressCount = useScoreExperimentWellsInProgressCount();
  const isFetchingExperimentData = useRMSelector(selectIsFetchingComposite);
  const experimentLoadProgress = useRMSelector(selectExperimentLoadingProgress);
  const zoomToPlateHandler = useZoomToPlateHandler(canvasStageRef);
  useFollowCanvasWell(canvasStageRef);
  const dropImageVerticalPrefetchingCount = useSystemProperty(
    PropertyConstants.DropImageVerticalPrefetchingCount,
    0,
  );
  const dropImageHorizontalPrefetchingCount = useSystemProperty(
    PropertyConstants.DropImageHorizontalPrefetchingCount,
    0,
  );
  const navigatorVerticalPrefetchingCount = useSystemProperty(
    PropertyConstants.CanvasNavigatorPrefetchingVertical,
    0,
  );

  const navigatorHorizontalPrefetchingCount = useSystemProperty(
    PropertyConstants.CanvasNavigatorPrefetchingHorizontal,
    0,
  );

  useEffect(() => {
    if (window?.location?.pathname.includes('/compare')) {
      setSelectedSidePanelTab(ESidePanelTabs.Navigator);
    }
  }, [window?.location?.pathname.includes('compare')]);

  useEffect(() => {
    if (window?.location?.pathname.includes('/info')) {
      setSelectedSidePanelTab(null);
    }
  }, [window?.location?.pathname.includes('info')]);

  const plateId = parseInt(window?.location?.pathname.split('/').pop(), 10);
  const selectedPlate = exp?.plateDto?.find((plate) => plate.plateId === plateId);
  const plateCount = exp?.plateDto?.length;
  useInitialPlateZoom({
    plateId,
    plateCount,
    selectedPlate,
    isScreenRoute: window.location.pathname.includes('/screen'),
    experimentLoadProgress,
    selectedSidePanelTab,
    canvasStageRef,
    canvasContainerRef,
    zoomToPlateHandler,
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('selectedMode')) {
      SetDisplayMode(params.get('selectedMode'));
      setHeader(params.get('selectedMode'));
      params.delete('selectedMode');
      history.replace({ pathname: location.pathname, search: params.toString() });
    }
  }, [location.search]);

  const isExpButtonsEnabled = Math.round(experimentLoadProgress) >= 100;

  const ExperimentHeaderPanelsProps: useExperimentHeaderPanelsProps = {
    displayMode: header,
    selectedTab: selectedSidePanelTab,
    setSelectedTab: setSelectedSidePanelTab,
    isButtonsDisabled: !isExpButtonsEnabled,
    zoomInvocker: zoomInvocker,
    rmLite,
    productEdition,
  };
  const [experimentHeaderPanelsHeaders, experimentHeaderPanelsContent] =
    useExperimentHeaderPanels(ExperimentHeaderPanelsProps);

  const [getScoreGroupsService] = useModel(
    ScoreGroupsService,
    'getScoreGroupsService',
    [],
  );

  const setIsEditModeState = useCallback(
    (isEditableActive) => dispatch(setIsEditMode(isEditableActive)),
    [dispatch],
  );
  const isDispensed = useRMSelector(selectIsDispensed);

  const clearDeletedLayersInStore = useCallback(
    () => dispatch(setDeleteLayerClear()),
    [dispatch],
  );

  const updateProgress = useCallback(
    (progress) => dispatch(setNotificationProgress(progress)),
    [dispatch],
  );

  const showProgressBar = useCallback(
    (show) => dispatch(showNotification(show)),
    [dispatch],
  );

  const setProgressMessage = useCallback(
    (message) => dispatch(setNotificationMessage(message)),
    [dispatch],
  );

  const resetGenCanvas = useCallback(() => dispatch(resetGenerateLayer()), [dispatch]);
  const _setScoresOptionsList = useCallback(
    (scoresList) => dispatch(setScoreOptionsList(scoresList)),
    [dispatch],
  );

  const _setIsRegionImaging = useCallback(
    (data) => dispatch(setIsRegionImaging(data)),
    [dispatch],
  );

  const selectedLayerIdRef = useRef<number | null>(null);
  const selectedLayerId = useRMSelector((state) => state?.experiment?.selectedLayerId);
  const _setSelectedLayerId = useCallback(
    (layerId: number) => dispatch(setSelectedLayerId(layerId)),
    [dispatch],
  );
  const _setUnselectLayer = useCallback(() => dispatch(setUnselectLayer()), [dispatch]);

  /**
   *RFR: we need to remove this reducer method, and come up with a more efficient way to render experiment after saving
   */
  const _setExpSaved = () => dispatch(setExpSaved());

  useEffect(() => {
    if (allWellImagingSettingDetails?.length > 1) {
      const link = `/exp/${
        exp.experimentId
      }/${plateID}/${wellNum}/${dropNumber}/${cpId}/${regionName}/${getImageBatchId(
        allWellImagingSettingDetails[0],
        plateID,
      )}/compare`;
      history.push(link);
    }
  }, [allWellImagingSettingDetails?.length]);

  useEffect(() => {
    if (exp?.isDispensed === false && GetDisplayMode() === DisplayModes.DESIGN) {
      setSelectedSidePanelTab(ESidePanelTabs.Layers);
    }
    if (
      exp?.isDispensed &&
      GetDisplayMode() === DisplayModes.IMAGE &&
      window?.location?.href.includes('setAnyHitFilter=true')
    ) {
      setSelectedSidePanelTab(ESidePanelTabs.Score);
    }
  }, [isExperimentLoaded, exp?.isDispensed]);

  useEffect(() => {
    setStateUpdated(true);
  }, [exp, expInfo]);

  useEffect(() => {
    const openedWindows = JSON.parse(localStorage.getItem('openedNodesIds'));
    const openedWindowsList = !openedWindows ? [] : openedWindows;
    if (!openedWindows || !openedWindowsList.find((win) => win == expid)) {
      openedWindowsList.push(expid);
      localStorage.setItem('openedNodesIds', JSON.stringify(openedWindowsList));
    }

    const removeDocumentFromOpenNodes = () => {
      const openedWindows = JSON.parse(localStorage.getItem('openedNodesIds'));
      if (openedWindows && openedWindows.length) {
        const openedWindowsList = openedWindows.filter((win) => win != expid);
        localStorage.setItem('openedNodesIds', JSON.stringify(openedWindowsList));
      }
    };

    window.addEventListener('beforeunload', removeDocumentFromOpenNodes);
    return () => {
      removeDocumentFromOpenNodes();
      window.removeEventListener('beforeunload', removeDocumentFromOpenNodes);
    };
  }, [expid]);

  useEffect(() => {
    let handle: IEventSubscription | null;

    const initializeConnection = async () => {
      try {
        // Get or create connection
        const connection = await connectionHubManager.getConnection(
          'notificationHub',
          '/notificationHub',
        );

        // Attaching all handlers
        handle = connection.attachHandlers([
          {
            eventName: 'Update',
            callback: (progress: number, total: number) => {
              updateProgress((progress / total) * 100);
            },
          },
          {
            eventName: 'SendMessage',
            callback: (message: string) => {
              setProgressMessage(message);
            },
          },
          {
            eventName: 'ShowNotification',
            callback: (show: boolean) => {
              showProgressBar(show);
            },
          },
        ]);
      } catch (error) {
        console.error('Notification hub init failed:', error);
      }
    };

    dispatch(layerExplorerDefaultSelectionThunk(PropertyConstants.ExplorerSidePanelOpen));
    initializeConnection();
    return () => {
      handle?.dispose();
      // Note: We don't stop the connection here since it's managed globally
    };
  }, []);

  useEffect(() => {
    if (reportType != '') {
      if (reportType == EReportTypes.IngredientReport && !isFetchingExperimentData) {
        setShowReportDialogue(false);

        const currentPlate = exp.plateDto.find((plate) => plate.plateId == plateID);

        let maxIngredients = 0;
        currentPlate.ingredients.wellList.forEach((well) => {
          let currentWellMaxIngredients = 0;
          well.wellLayerList.forEach((lyrList) => {
            currentWellMaxIngredients =
              currentWellMaxIngredients + lyrList.wellLayerIngredientList.length;
          });
          if (currentWellMaxIngredients > maxIngredients) {
            maxIngredients = currentWellMaxIngredients;
          }
        });
        if (maxIngredients == 0) {
          showAlertSnackBar(
            EAlertType.WARNING,
            ESnackBarPosition.TOP,
            'Plate has no ingredients.',
          );
          setReportType('');
        } else {
          setShowReportDialogue(true);
        }
      } else if (
        reportType == EReportTypes.ExperimentReport ||
        reportType == EReportTypes.DesignReport
      ) {
        if (selectedLayerId > 0) {
          selectedLayerIdRef.current = selectedLayerId;
          _setUnselectLayer();
        }

        if (GetDisplayMode() != DisplayModes.DESIGN) {
          let reportName = 'experiment';
          if (reportType == EReportTypes.DesignReport) {
            reportName = 'design';
          }
          showModalSimple({
            body: (
              <text id="experiment-dashboard-designreport-message">
                Design view will be selected to generate {reportName} report. Do you want
                to continue?
              </text>
            ),
            onOk: () => {
              hideModal();
              SetDisplayMode(DisplayModes.DESIGN);
              const basePath = window.location.pathname.includes('/screen')
                ? `/screen/${expid}`
                : `/exp/${expid}`;
              history.push({
                pathname: basePath,
                search: `?selectedMode=${DisplayModes.DESIGN}`,
              });
              setShowReportDialogue(true);
            },
            heading: 'Warning',
            dialogClassName: 'min-w-[500px] m-0',
            okButtonText: 'Ok',
            isCancelOnly: false,
            onCancel: () => {
              setReportType('');
              hideModal();
            },
            onHide: () => {
              setReportType('');
              hideModal();
            },
          });
        } else {
          setShowReportDialogue(true);
        }
      } else {
        setShowReportDialogue(true);
      }
    } else {
      if (selectedLayerId < 0) {
        _setSelectedLayerId(selectedLayerIdRef.current);
      }
      setShowReportDialogue(false);
    }
  }, [reportType]);

  const isProgressBarVisible = useRMSelector(selectShowProgress);
  const lastRoundedProgressRef = useRef<number | null>(null);

  useEffect(() => {
    dispatch(
      setNotification({
        showProgress: true,
        message: 'Loading Experiment...',
        progressStatus: NotificationProgressStatus.InProgress,
      }),
    );

    // Make sure progress bar is hidden when navigating away
    return () => {
      dispatch(
        setNotification({
          showProgress: false,
          message: 'Loaded Successfully',
          progressStatus: NotificationProgressStatus.Done,
        }),
      );
    };
  }, [dispatch]);

  useEffect(() => {
    if (isProgressBarVisible) {
      const roundedProgress = Math.round(experimentLoadProgress);

      if (lastRoundedProgressRef.current !== roundedProgress) {
        lastRoundedProgressRef.current = roundedProgress;
        dispatch(setNotificationProgress(roundedProgress));

        if (roundedProgress >= 99) {
          dispatch(
            setNotification({
              showProgress: false,
              progress: 100,
              message: 'Loaded Successfully',
              progressStatus: NotificationProgressStatus.Done,
            }),
          );
        }
      }
    }
  }, [dispatch, isProgressBarVisible, experimentLoadProgress]);

  function layerMode(setOn = null) {
    if (setOn !== null) {
      setIsLayerMode(setOn);
      setCursorClass(setOn == true ? 'crosshair-pointer' : '');
    } else {
      setCursorClass(isLayerMode ? 'crosshair-pointer' : '');
      setIsLayerMode(!isLayerMode);
    }
  }
  const setAllPlatesAtImagerStatus = useCallback(async () => {
    const allPlatesStatus = await _experimentService.getAllPlatesAtImagerStatus(expid);
    dispatch(setPlatesAtImagerStatus(allPlatesStatus));
  }, [expid]);

  const setAllMotherPlatesScoringStatuses = useCallback(async () => {
    const allPlatesStatus = await _gpService.getAllMotherPlatesScoringStatuses(expid);
    dispatch(setMotherPlatesScoringStatuses(allPlatesStatus));
  }, [expid]);

  async function fetchExperimentData() {
    canvasWidth = GetUnifiedExperimentCanvasWidth(widthMainDiv);
    const userToken = await getUserToken();
    if (isNullOrUndefined(userToken)) {
      history.push('/login');
      return null;
    }
    try {
      await dispatch(
        fetchExperimentAsync(
          expid,
          window.location.pathname.includes('/screen')
            ? ETreeNodeTypes.Screen
            : ETreeNodeTypes.Experiment,
          productEdition,
          queryWellNumber,
          queryPlateId,
        ),
      );
      treeService
        .getDocumentParentNodes(expid, ETreeNodeTypes.Experiment, true)
        .then((data) => {
          setExpHeaderName(data?.[0]?.name);
          setBreadCrumbs(data);
        });
    } catch (error) {
      if (error.status == 404) {
        setIsResourceAvailable(false);
        showFileNotFoundModal();
        return;
      } else {
        throw error;
      }
    }
    fetchAndSetNavigatorMap(expid);
    setAllPlatesAtImagerStatus();
    setAllMotherPlatesScoringStatuses();
    /**
     *RFR-TODO: We need to remove this state
     */
    setStateUpdated(true);
    dispatch(setIsFetchingExperimentData(false));
  }

  //RFR: Remove this function
  useEffect(() => {
    async function fetchScoresGroups() {
      const data: ScoresGroupsDTO[] = await getScoreGroupsService();
      if (data === null) {
        return null;
      }
      _setScoresOptionsList(getPlainScoreOptionsList(data));
      setRefresh(true);
    }

    fetchScoresGroups();
  }, []);

  useEffect(() => {
    if (exp == null) {
      if (productEdition) {
        fetchExperimentData();
      }
    }
  }, [exp, productEdition]);

  function changeIconPanels(panelName) {
    if (panelName == '') {
      openedSideBars = 0;
      widthMainDiv = 100;
      canvasWidth = GetUnifiedExperimentCanvasWidth(widthMainDiv);
      setOpenedIconPanel(panelName);
    } else if (panelName == EIconPanels.ImageNow) {
      setShowLayers(false);
      openedSideBars = 1;
      widthMainDiv = 70;
      canvasWidth = GetUnifiedExperimentCanvasWidth(widthMainDiv);
      setPanelsState((prevState) => ({ ...prevState, [panelName]: true }));
    } else {
      setDrawingLayerType(panelName);
      layerMode(true);
    }
  }

  function changeShowLayersCanvas(open = null) {
    if (!showLayers) {
      setShowLayers(true);
      openedSideBars += 1;
      widthMainDiv = 70;
      canvasWidth = GetUnifiedExperimentCanvasWidth(widthMainDiv);
    }
    if (open == true) {
      setShowLayers(open);
      layerMode(false);
    } else {
      setShowLayers(!showLayers);
    }
  }
  //RFR-REMOVE: we need to remove this function
  function changeHeader(name) {
    switch (name) {
      case 'showDesign':
        setHeader(DisplayModes.DESIGN);
        break;
      case 'showImage':
        setHeader(DisplayModes.IMAGE);
        break;
      case 'showScore':
        setHeader(DisplayModes.SCORE);
        break;
      case 'showWellImage':
        setHeader(DisplayModes.WELLIMAGE);
        break;
      case 'showScreen':
        setHeader(DisplayModes.SCREEN);
        break;
      case 'showWellIngredient':
        setHeader(DisplayModes.WELLINGREDIENT);
        break;
      default:
    }
    setRefresh(true);
  }

  function onDiscardButtonClick(e) {
    expInfo.IsDirty = false;
    dispatch(discardExperimentChanges());
    dispatch(setShouldShowLayerIngredientPanel(false));
    setIsDirty(false);
    clearDeletedLayersInStore();
    setStateUpdated(!stateUpdated);
    setRefresh(true);

    //** Set Wells and Canvas Labels to original state
    const { wellLabels, canvasLabels } = getWellAndCanvasLabels(
      expOriginal.containerCols,
      expOriginal.containerRows,
    );
    SetWellsLabels(wellLabels);
    SetCanvasLabels(canvasLabels);
  }

  function isExpDefinationChanged() {
    if (expDefinationChanged) {
      setExpDefinationChanged(false);
      return true;
    }
    return false;
  }
  function setExpHeaderName(name) {
    setExpName(name);
    document.title = name;
  }
  async function setScoreViewRef(scoreviewRefFromExp) {
    scoreViewRef = scoreviewRefFromExp;
    setRefresh(true);
  }
  function setScoreView(e) {
    if (!isScoringFeatureEnabled(productEdition)) {
      return;
    }
    SetDisplayMode(DisplayModes.SCORE);
    scoreViewRef(e);
    setRefresh(true);
  }

  async function setImageView(e) {
    if (header === DisplayModes.IMAGE) {
      SetDisplayMode(DisplayModes.IMAGE);
    } else {
      SetDisplayMode(DisplayModes.IMAGESCORE);
    }
    setRefresh(true);
  }
  function updateExpData(expData) {
    setExp({ ...expData });
  }
  function updateRoute(link) {
    history.push(link);
    return null;
  }
  function setZoomInvocker(functionDelegate) {
    savedZoomFunctionDelegate.current = functionDelegate;
  }
  function zoomInvocker(zoomIn) {
    if (
      GetDisplayMode() === DisplayModes.WELLIMAGE &&
      wellNum &&
      plateID &&
      dropNumber &&
      cpId &&
      inspection &&
      regionName
    ) {
      triggerZoom(
        getNavigatorImageKeysAsString(
          { plateID, wellNum, plateNum },
          { dropNumber, cpId, inspection, regionName },
        ),
        zoomIn,
      );
    } else {
      if (savedZoomFunctionDelegate?.current) {
        savedZoomFunctionDelegate.current(zoomIn);
      }
    }
  }

  function fitToPlateInvoker(plateId) {
    if (!exp?.plateDto?.length) {
      return;
    }
    if (exp.plateDto.length === 1) {
      // handle single plate
      // same method invoked by 'Best Fit' button
      zoomInvocker(0);
      return;
    }
    zoomToPlateHandler(plateId);
  }

  function saveExperiment(e) {
    let isImagingSchedulDeleted = false;
    if (getExperimentInfoIsDirty()) {
      const tempExp = ExperimentInfoDTO.fromJS(exp.info as ExperimentInfoDTO);
      if (!tempExp.name || tempExp.name === '') {
        setModalDetails({
          ...modalDetails,
          isOkOnly: true,
          showModal: true,
          onOk: () => setModalDetails({ ...modalDetails, showModal: false }),
          body: 'Experiment name cannot be empty.',
          heading: 'Warning',
          okButtonText: 'Ok',
        });
        return;
      } else if (tempExp.name.length > 64) {
        setModalDetails({
          ...modalDetails,
          isOkOnly: true,
          showModal: true,
          onOk: () => setModalDetails({ ...modalDetails, showModal: false }),
          body: (
            <div id="experiment-dashboard-save-experiment-fmlx-banner">
              <FmlxBanner
                id="experiment-dashboard-save-experiment-fmlx-banner-error"
                variant="error"
                title={`"${tempExp.name}" is too long.`}
                show
                hideCloseButton
              />
              <div
                id="experiment-dashboard-save-experiment-fmlx-banner-error-message"
                style={{ margin: '8px' }}
              >
                Please make sure the experiment name is no more than 64 characters.
              </div>
            </div>
          ),
          heading: 'Error',
          okButtonText: 'CLOSE',
        });
        return;
      }
    }
    if (
      !isNullOrUndefined(exp.imagingSchedule) &&
      exp.imagingSchedule?.imagingScheduleEntries?.length > 0
    ) {
      if (duplicateImagingScheduleRows?.length) {
        setModalDetails({
          ...modalDetails,
          showModal: true,
          onOk: () => {
            setModalDetails({ ...modalDetails, showModal: false });
          },
          body: DuplicateImageScheduleEntriesBody(duplicateImagingScheduleRows),
          heading: 'Error',
          isOkOnly: true,
          okButtonText: 'Okay',
        });
        return;
      }
      for (const entry of exp.imagingSchedule.imagingScheduleEntries) {
        if (!entry.isSelected) {
          const index = exp.imagingSchedule.imagingScheduleEntries.findIndex(
            (e) =>
              e.days === entry.days &&
              e.hours === entry.hours &&
              e.isSelected &&
              entry.id === e.id,
          );
          if (index < 0 && exp.imagingSchedule.selectedImagingScheduleId == entry.id) {
            isImagingSchedulDeleted = true;
            break;
          }
        }
      }
    }
    if (isImagingSchedulDeleted) {
      setModalDetails({
        ...modalDetails,
        showModal: true,
        onOk: () => saveExperimentAfterValidation(),
        body: 'Some imaging tasks do not have any imaging settings selected. Do you want to delete them to continue saving?',
        heading: 'Warning',
        okButtonText: undefined,
        isOkOnly: false,
        isCancelOnly: false,
      });
      return;
    }
    saveExperimentAfterValidation();
  }
  function saveExperimentAfterValidation() {
    setModalDetails({ ...modalDetails, showModal: false });
    if (exp.isDirty || getImageSchedulesIsDirty() || getExperimentInfoIsDirty()) {
      saveExperimentRequest(deletedLayers);
    }
  }
  useEffect(() => {
    dispatch(setHideAutoScores(false));
  }, []);

  useEffect(() => {
    setIsCanvasInFocus(true);
  }, [
    wellNavigationDetails?.plateID,
    wellNavigationDetails?.wellNum,
    selectedDropImageParameters?.cpId,
    selectedDropImageParameters?.dropNumber,
    selectedDropImageParameters?.regionName,
    selectedDropImageParameters?.inspection,
  ]);

  const fetchAndSetNavigatorMap = async (expId: number) => {
    const navigatorMap: NavigatorMapDTO =
      await _experimentService.getCompositeNavigatorData(expId);
    setNavigatorMap(navigatorMap);
  };
  function isStateUpdated() {
    if (stateUpdated) {
      setStateUpdated(false);
      return true;
    }
    return false;
  }
  function changeCompareMode(mode) {
    setCompareMode(mode);
  }
  function getExperimentDesignerIsDirty() {
    if (isNullOrUndefined(exp) || exp.isDirty === false) {
      return false;
    }
    return true;
  }

  const printBarcodeHandler = useCallback(
    async (printType: PrintType = PrintType.ExperimentBarcode) => {
      showSnackBar('Sent for Print Barcode');
      const expId = exp?.experimentId;
      if (exp && expId) {
        let printResponse: PrintBarcodeApiResponse = null;
        if (printType === PrintType.ExperimentBarcode) {
          const plateService = new ScoreGroupsService();
          printResponse = await plateService.printPlateBarcode(plateID);
        } else if (printType === PrintType.ExperimentInformation) {
          const printingService = new PrintingService();
          printResponse = await printingService.printExperimentInformation(plateID);
        }
        if (printResponse && printResponse.value != '') {
          showLabelPrinterError();
        } else if (printResponse?.infoMessage) {
          showAlertSnackBar(
            EAlertType.WARNING,
            ESnackBarPosition.TOP,
            printResponse.infoMessage,
          );
        }
      } else {
        showAlertSnackBar(
          EAlertType.ERROR,
          ESnackBarPosition.TOP,
          'Something went wrong, please try again later',
        );
      }
    },
    [plateID, exp],
  );

  const alertConfig: Record<
    string,
    {
      okButtonText: string;
      onOk: () => void;
    }
  > = {
    'File Not Found': {
      okButtonText: 'GO TO HOMEPAGE',
      onOk: () => {
        history.push('/');
        hideModal();
      },
    },
  };

  async function saveExperimentRequest(pDeletedLayers: Array<LayerDTO> = []) {
    saveAttemptedOnLyrs(exp.layers);
    const errorDetails = validate(exp, true);
    if (errorDetails.hasError) {
      setModalDetails({
        ...modalDetails,
        showModal: true,
        setShowModal: () => setModalDetails({ ...modalDetails, showModal: false }),
        onOk: () => setModalDetails({ ...modalDetails, showModal: false }),
        body: (
          <AlertBoxBody
            type="error"
            title={errorDetails.error}
            message="You can't save the changes. Please fix the above error."
          />
        ),
        heading: 'Save Failed',
        okButtonText: 'CLOSE',
        isOkOnly: true,
      });
      /**
       * RFR: we need to remove this reducer method, and come up with a more efficient way to render experiment after saving
       */
      genCanvas();
      return;
    }
    resetGenCanvas();
    setRefresh(true);
    const plates: SavePlateDTO[] = [];
    const deletedplateIds = [...exp.deletedPlateIds] as number[];
    for (const plate of exp.plateDto) {
      const pl = {
        ingredients: plate.ingredients,
        rowPos: plate.rowPos,
        colPos: plate.colPos,
      };
      const plateHaveLayer = isPlateHaveLayer(plate, exp.layers);
      if (plateHaveLayer) {
        plates.push(SavePlateDTO.fromJS(pl));
      } else if (plate.plateId > 0) {
        deletedplateIds.push(plate.plateId);
      }
    }

    try {
      let screenRepairInfo: ScreenRepairInfoDTO = null;
      if (window.location.pathname.includes('/screen')) {
        screenRepairInfo = await preSaveRepairScreen(exp, showModal);
        if (!screenRepairInfo.isOk) {
          return;
        }
      }

      const saveExpDTO = createSaveExpDTO(
        exp,
        plates,
        deletedplateIds,
        pDeletedLayers,
        importedIngredientCoflicts,
      );
      const expService = new ExperimentService();
      loadingText = 'Saving Experiment';
      setIsLoading(true);
      const response = await expService.saveExperiment(saveExpDTO);

      if (!response || !response?.experimentData) {
        setIsLoading(false);
        setExpInfoIsDirty(false);
        setIsDirty(false);
        if (response?.alert) {
          const { alertTitle, alertMessage } = response?.alert || {};
          if (alertTitle === 'File Not Found') {
            setIsResourceAvailable(false);
          }
          const config = alertConfig[alertTitle] || {
            okButtonText: 'OK',
            onOk: hideModal,
          };

          showModalSimple({
            customHeader: alertTitle && (
              <div
                id="experiment-dashboard-save-experiment-request-alert-title"
                className="px-6 py-4 flex items-center font-roboto text-xl leading-[120%] font-normal text-[#f7a246]"
              >
                {alertTitle}
              </div>
            ),
            body: alertMessage,
            isOkOnly: true,
            okButtonText: config.okButtonText,
            onOk: config.onOk,
            hideCloseButton: true,
            isModalEscapeable: false,
          });
        } else {
          showAlertSnackBar(
            EAlertType.ERROR,
            ESnackBarPosition.TOP,
            'Cannot Save Experiment!',
          );
        }
        setRefresh(true);
        return null;
      }
      setImportedIngredientCoflicts(null);
      const result = response;
      if (response?.experimentData) {
        if (response.experimentData.expInfoResponse.isTreeNodeNameExist) {
          setIsLoading(false);
          showAlertSnackBar(
            EAlertType.ERROR,
            ESnackBarPosition.TOP,
            'Name already exists, please choose another name.',
          );
          dispatch(setExperimentInfo({ name: exp.expName }));
          return;
        }
        //Repair Screen
        if (window.location.pathname.includes('/screen')) {
          const screenRepairUpdateInfo = await expService.repairScreenExperiments(
            screenRepairInfo,
          );
          if (Object.keys(screenRepairUpdateInfo.invalidExperimentInfo).length > 0) {
            let experimentNamesWithIds = '';
            for (const id in screenRepairUpdateInfo.invalidExperimentInfo) {
              experimentNamesWithIds += `${screenRepairUpdateInfo.invalidExperimentInfo[id]} - ${id}\n`;
            }

            const body =
              'The following experiment(s) could not be repaired: \n' +
              experimentNamesWithIds;
            setModalDetails({
              ...modalDetails,
              isOkOnly: true,
              showModal: true,
              onOk: () => setModalDetails({ ...modalDetails, showModal: false }),
              body: body,
              heading: 'Warning',
              okButtonText: 'Ok',
            });
          }
        }

        if (result.experimentData.globalIngredients) {
          await SetIngredients(result.experimentData.globalIngredients);
        }
        await processAndSaveExperiment(result?.experimentData);
        if (exp.info) {
          setExpHeaderName(exp.info.name);
          setBreadCrumbs((prev) => {
            const updated = [...prev];
            updated[0] = {
              ...updated[0],
              name: exp.info.name,
            };
            return updated;
          });

          const treeService: TreeService = new TreeService();
          const treeNode = await treeService.getTreeNodeByExpId(expid);
          explorerBroadcastChannel.postMessage({
            action: CHANNEL_ACTIONS.EXPLORER_RENAME_NODE,
            payload: treeNode,
          });
        }
        setExpInfoIsDirty(false);
        clearDeletedLayersInStore();
        setIsEditModeState(!isDispensed);
        clearUndoStack();
        /**RFR: We need to remove plateId from wellNavigationDetails and refer plateID from PlateDTO always */

        const wellNavigationDetailsAfterSave = allWellNavigationDetails.map((well) => {
          const plateId =
            store.getState().experiment.expData.plateDto[well.plateNum - 1]?.plateId;
          return {
            ...well,
            plateID: plateId,
          };
        });
        dispatch(setWellNavigationDetails(wellNavigationDetailsAfterSave));
        _setExpSaved();
        setIsDirty(false);
      }
      setIsLoading(false);
      if (response?.experimentData) {
        showAlertSnackBar(
          EAlertType.SUCCESS,
          ESnackBarPosition.TOP,
          'Saved successfully.',
        );
      }
      setRefresh(true);
    } catch (err) {
      setIsLoading(false);
      showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, err.message);
    }
    setRefresh(true);
  }

  function BottomMenuComponent() {
    if (exp === null) {
      return;
    }

    return (
      <BottomMenu
        docData={exp}
        plateLables={exp.plateLables}
        wellLables={exp.wellLables}
        dropLables={exp.dropLables}
        regions={exp.regions}
        profiles={exp.profiles}
        inspections={exp.inspections}
        setScoreView={setScoreView}
        setImageView={setImageView}
        zoomInvocker={zoomInvocker}
        fitToPlateInvoker={fitToPlateInvoker}
        setStartWellSlideShow={setStartWellSlideShow}
        setSlideShowInitiatedFromCanvas={setSlideShowInitiatedFromCanvas}
        isDisabled={!isExpButtonsEnabled}
      />
    );
  }
  /**
   * RFR: we need to remove this refresh state, and come up with better way to render the component
   */
  if (refresh) {
    setRefresh(false);
  }
  function getOrignalLayers() {
    // When we delete a layer that is saved but we have done some changes in it but eventually delete it
    // then we need to fetch the last saved layer, so that it can easily be deleted on server
    return expOriginal.layers;
  }
  function setRefSaveImage(saveImage) {
    refSaveImage = saveImage;
  }

  function saveImageClick() {
    if (rmLite && GetDisplayMode() != DisplayModes.IMAGE) {
      const saveImageParams: SaveWellDropImageParams = {
        selectedCaptureProfileIds: [cpId],
        saveAllDrops: false,
        saveAllRegions: false,
        saveAllInspections: false,
        saveAllFocusLevels: false,
        saveAllWellDropScores: true,
        saveAnnotations: showOverlays,
        saveScaleBar: showScaleBar,
        saveCurrentZoom: false,
        onCompleteSaveImage: (response: FileSystemTaskResultDTO) => {
          if (!response?.responseFile?.data?.size) {
            showAlertSnackBar(
              EAlertType.WARNING,
              ESnackBarPosition.TOP,
              'No files found!',
            );
            return;
          }
          const { data, fileName } = response.responseFile;
          const downloadName = fileName?.endsWith('.zip')
            ? fileName
            : `Image_${plateID}_${wellNum}_Drop${dropNumber}_${cpId}.jpg`;
          downloadFile(data, downloadName);
          showAlertSnackBar(
            EAlertType.SUCCESS,
            ESnackBarPosition.TOP,
            'File succesfully downloaded!',
          );
        },
        onErrorSaveImage: (response) => {
          showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, response.message);
        },
      };
      saveWellDropImage(saveImageParams);
      return;
    }
    setModalDetails({
      ...modalDetails,
      showModal: true,
      onOk: () => refSaveImage(),
      body: (
        <SaveImage
          setRefSaveImage={setRefSaveImage}
          regions={exp && exp.regions}
          inspections={exp.inspections}
          modalDetails={modalDetails}
          setModalDetails={setModalDetails}
          setModalOkDisabled={setModalOkDisabled}
        />
      ),
      heading: 'Save Image',
      okButtonText: 'Save Image',
    });
  }

  async function onRotateCanvas() {
    RotateScreenCanvas(
      exp.layers,
      exp.isDirty,
      exp.plateDto.length,
      exp.treeNodeId,
      showRotateCanvasMessageBox,
      updatedProperties,
      showAwaitableModal,
      showLoadingModal,
      hideModal,
      <RotateCanvasModal onChange={onChangeRotateCanvasMessageBoxValue} />,
    );
  }

  const onChangeRotateCanvasMessageBoxValue = async (e: any, showModal, setShowModal) => {
    const prop: BasePropertyDTO = new BasePropertyDTO({
      displayName: 'Show Rotate Canvas MessageBox',
      name: 'Screen.RotateCanvas.ShowMessageBox',
      categoryName: 'Misc',
    });

    if (prop instanceof BooleanPropertyDTO) {
      prop.value = e;
    }

    const idx = updatedProperties.findIndex((p) => p.name === prop.name);
    if (idx >= 0) {
      updatedProperties[idx] = prop;
    } else {
      updatedProperties.push(prop);
    }
    setShowRotateCanvasMessageBox(!showModal);
    setShowModal(!showModal);
  };

  async function onMarkAsDispensed() {
    if (exp.isDirty) {
      showAlertSnackBar(
        EAlertType.ERROR,
        ESnackBarPosition.TOP,
        'This Experiment is open and has been modified. Please save the Experiment before dispensed.',
      );
    } else {
      const heading = 'Mark as Dispensed';
      const body =
        'Marking Experiment as dispensed will render a reload, do you want to continue?';

      if (await showModal(heading, body)) {
        loadingText = 'Marking as dispensed';
        setIsLoading(true);
        const response: AlertDTO =
          await new ExperimentService().markExperimentAsDispensed(expid);
        setIsLoading(false);
        if (response.alertType == EAlertType.ERROR) {
          showAlertSnackBar(
            EAlertType.ERROR,
            ESnackBarPosition.TOP,
            response.alertMessage,
          );
        } else {
          window.location.reload();
        }
      }
    }
  }

  const deleteInspection = async () => {
    if (selectedInspectionSet.groupedInspections.length > 0) {
      setModalDetails({ ...modalDetails, showModal: false });
      loadingText = 'Delete Inspection';
      setIsLoading(true);
      await dispatch(deleteInspectionsAsync(selectedInspectionSet));
      setIsLoading(false);
      showAlertSnackBar(
        EAlertType.SUCCESS,
        ESnackBarPosition.TOP,
        'Selected Inspection has been deleted...',
      );
    } else {
      showAlertSnackBar(
        EAlertType.ERROR,
        ESnackBarPosition.TOP,
        'No Inspection is available...',
      );
    }
  };
  const deleteInspectionClick = () => {
    setModalDetails({
      ...modalDetails,
      showModal: true,
      onOk: deleteInspection,
      body: 'Are you sure you want to delete selected inspection?',
      heading: 'Confirmation',
      isOkOnly: false,
      isCancelOnly: false,
    });
  };
  const editExperimentClick = licenseAuthCommand(() => {
    setModalDetails({
      ...modalDetails,
      showModal: true,
      onOk: () => {
        setIsEditModeState(true);
        dispatch(preserveExpData());
        setModalDetails({ ...modalDetails, showModal: false });
      },
      body: 'This experiment has already been dispensed. Are you sure you want to make changes?',
      heading: 'Edit Experiment',
      okButtonText: 'Yes',
      noButtonText: 'No',
      isOkOnly: false,
      isCancelOnly: false,
    });
  }, EUserAction.EditExperiment);

  if (canvasWidth !== GetUnifiedExperimentCanvasWidth(widthMainDiv)) {
    canvasWidth = GetUnifiedExperimentCanvasWidth(widthMainDiv);
    setRefresh(true);
    setOpenedIconPanel('');
  }

  const sidePanelWidth = experimentHeaderPanelsContent
    ? (experimentHeaderPanelsContent as React.Component<ITabPanelProps>).props.width
    : 0;

  const _calculateCanvasWidth = () => {
    widthMainDiv = 100 - sidePanelWidth;

    return GetUnifiedExperimentCanvasWidth(widthMainDiv);
  };

  const sizeDetails = useMemo(
    () => ({
      canvasWidth: _calculateCanvasWidth(),
      canvasHeight:
        GetUnifiedExperimentCanvasHeight() - (window.innerHeight < 700 ? 20 : 0),
    }),
    [sidePanelWidth],
  );
  const onExportPoi = async () => {
    const isDropMode = isDropModeUrl();
    const regionId = exp.regions
      .find((r) => r.name === regionName)
      ?.drops?.find((d) => d.wellNumber === wellNum)?.regionId;
    await exportPOI(
      exp?.experimentId,
      plateID,
      isDropMode ? wellNum : null,
      isDropMode ? dropNumber : null,
      isDropMode ? regionId : null,
      isDropMode,
    );
  };

  function getImageBatchId(recentNavDetail: DropImageParameters, plateId: number) {
    let imgBatchId = 0;
    const plateInspection = recentNavDetail?.inspection?.groupedInspections?.find(
      (insp) => insp.plateId == plateId,
    );
    if (plateInspection != undefined) {
      imgBatchId = plateInspection.imageBatchId;
    }
    return imgBatchId;
  }

  const maxPlateState = useMemo(
    () =>
      exp?.plateDto?.length ? Math.max(...exp.plateDto.map((plate) => plate.state)) : -1,
    [exp?.plateDto],
  );

  const setWellRef = (wellKey: string, ref: any) => {
    if (ref) {
      wellRefs.current[wellKey] = ref;
    } else {
      delete wellRefs.current[wellKey];
    }
  };

  const triggerZoom = (wellKey: string, zoomIn) => {
    if (wellRefs.current[wellKey]) {
      wellRefs.current[wellKey].ZoomHandler(zoomIn);
    }
  };
  if (!isNullOrUndefined(exp) && exp.accessRightName === null) {
    showAlertSnackBar(
      EAlertType.ERROR,
      ESnackBarPosition.TOP,
      'Access Denied to the requested experiment!',
    );
    history.push('/Project');
    return;
  }

  if (!isResourceAvailable) {
    return;
  }
  return (
    <ExpDashboardContext.Provider
      value={{
        fileExportActionType,
        setFileExportActionType,
        fileImportActionType,
        setFileImportActionType,
        setSelectedSidePanelTab,
        selectedSidePanelTab,
        importedIngredientCoflicts,
        setImportedIngredientCoflicts,
        imagedWells,
        triggerZoom,
        cursorClass,
        setCursorClass,
        canvasContainerRef,
        isCanvasInFocus,
        setIsCanvasInFocus,
        selectedCanvasRoute,
        setSelectedCanvasRoute,
        navigatorMap,
        dropImageVerticalPrefetchingCount,
        dropImageHorizontalPrefetchingCount,
        navigatorVerticalPrefetchingCount,
        navigatorHorizontalPrefetchingCount,
      }}
    >
      <LoadingModal showModal={isLoading} text={loadingText} />

      {scoreExperimentWellsInProgressCount > 0 && (
        <div className="flex flex-row items-center gap-x-3 progressBar">
          <FmlxProgressBar type="circular" variant="indeterminate" />
          <div>{`Applying ${scoreExperimentWellsInProgressCount} Score(s)`}</div>
        </div>
      )}
      <DragContextProvider>
        <div
          id="experiment-dashboard-drag-wrapper"
          className={cursorClass}
          style={{ height: '100%' }}
        >
          <ExperimentHeader
            panelsState={panelsState}
            isDirty={getExperimentDesignerIsDirty() || getIsDirty()}
            changeCompareMode={changeCompareMode}
            expName={expName}
            regions={exp && exp.regions}
            headerType={header}
            saveExperiment={saveExperiment}
            onDiscardButtonClick={onDiscardButtonClick}
            accessRightName={
              !isNullOrUndefined(exp) && exp.accessRightName ? exp.accessRightName : null
            }
            isDropImageAvailable={isDropImageAvailable}
            changeIconPanels={changeIconPanels}
            showLayers={showLayers}
            openedSidebars={openedSideBars}
            setShowOptimize={setShowOptimize}
            setReportType={setReportType}
            pathName={window.location.pathname}
            deleteSelectedInspection={() => {}}
            saveImageClick={saveImageClick}
            editExperimentClick={editExperimentClick}
            setShowSeedFormulation={setShowSeedFormulation}
            setScoreView={setScoreView}
            setImageView={setImageView}
            sidePanelHandlers={experimentHeaderPanelsHeaders}
            exportPoi={onExportPoi}
            deleteInspection={deleteInspectionClick}
            printBarcode={printBarcodeHandler}
            isHeaderButtonsDisabled={!isExpButtonsEnabled}
            isPasteNotAllowed={isPasteNotAllowed}
            setRegionImaging={_setIsRegionImaging}
            rotateCanvas={onRotateCanvas}
            markAsDispensed={onMarkAsDispensed}
            exportFrapDataPoints={exportFrapDataPoints}
            disableFrapExport={isDropModeUrl() || !isFrap}
            disablePrintBarcode={!(maxPlateState >= 0)}
            breadCrumbs={breadCrumbs}
            inspections={exp?.inspections}
            isImagedExperiment={getDefaultInspection(exp) ? true : false}
            isResourceAvailable={isResourceAvailable}
          />
          <div
            id="experiment-dashboard-drag-section"
            style={{ maxWidth: '100%', width: '100%', height: '89.4%' }}
          >
            <div
              id="experiment-dashboard-drag-content"
              style={{
                display: 'flex',
                width: '100%',
                height: '100%',
              }}
            >
              <ModalContainer
                modalDetails={modalDetails}
                setModalDetails={setModalDetails}
                modalOkDisabled={modalOkDisabled}
              />
              <Switch>
                <Route
                  exact
                  path="/exp/:id/info"
                  render={(props) => (
                    <ExperimentInfo
                      wellLables={GetWellsLabels()}
                      panelsState={panelsState}
                      widthMainDiv={widthMainDiv}
                      setExpNameHeader={setExpHeaderName}
                      setHeader={setHeader}
                      setRefresh={setRefresh}
                      openedSideBars={openedSideBars}
                      setIsInfoLoaded={setIsExperimentLoaded}
                      {...props}
                    />
                  )}
                />
                <Route
                  exact
                  path="/screen/:id/info"
                  render={(props) => (
                    <ExperimentInfo
                      wellLables={GetWellsLabels()}
                      panelsState={panelsState}
                      widthMainDiv={widthMainDiv}
                      setExpNameHeader={setExpHeaderName}
                      setHeader={setHeader}
                      setRefresh={setRefresh}
                      openedSideBars={openedSideBars}
                      isScreenRoute={true}
                      setIsInfoLoaded={setIsExperimentLoaded}
                      {...props}
                    />
                  )}
                />
                <Route
                  exact
                  path={
                    '/exp/:id/:plateID/:wellNum/:dropNumber/:cpID/:regionName/:imageBatchId/:wellMode?'
                  }
                  render={(props) => {
                    if (
                      productEdition === EProductEditions.ExperimentDesigner &&
                      !rmLite
                    ) {
                      history.push({
                        pathname: '/licenseviolate',
                        state: { detail: RMLicenseHttpStatusCode.FeatureViolation },
                      });
                      return <div>Something went wrong...</div>;
                    } else {
                      return (
                        <WellDashboard
                          sizeDetails={sizeDetails}
                          setIsWellLoaded={setIsExperimentLoaded}
                          setZoomInvocker={setZoomInvocker}
                          gridLayout={compareMode}
                          changeHeader={changeHeader}
                          BottomMenu={BottomMenuComponent()}
                          startWellSlideShow={startWellSlideShow}
                          setStartWellSlideShow={setStartWellSlideShow}
                          isSlideShowInitiatedFromCanvas={isSlideShowInitiatedFromCanvas}
                          navigatorMap={navigatorMap}
                          setWellRef={setWellRef}
                          {...props}
                        />
                      );
                    }
                  }}
                />

                <Route
                  path="/screen/:id"
                  render={(props) => (
                    <Screen
                      exp={exp}
                      expId={expid}
                      showLayers={showLayers}
                      reportType={reportType}
                      panelsState={panelsState}
                      isLayerMode={isLayerMode}
                      stateUpdated={stateUpdated}
                      showOptimize={showOptimize}
                      widthMainDiv={widthMainDiv}
                      openedSideBars={openedSideBars}
                      nodeMenuDetails={nodeMenuDetails}
                      imageNowDetails={imageNowDetails}
                      openedIconPanel={openedIconPanel}
                      drawingLayerType={drawingLayerType}
                      paramsExpId={parseInt(props.match.params.id)}
                      updateRoute={updateRoute}
                      zoomInvocker={zoomInvocker}
                      changeHeader={changeHeader}
                      setReportType={setReportType}
                      updateExpData={updateExpData}
                      wellLables={GetWellsLabels()}
                      isStateUpdated={isStateUpdated}
                      setScoreViewRef={setScoreViewRef}
                      setShowOptimize={setShowOptimize}
                      setZoomInvocker={setZoomInvocker}
                      BottomMenu={BottomMenuComponent()}
                      getOrignalLayers={getOrignalLayers}
                      changeShowLayers={changeShowLayersCanvas}
                      isExpDefinationChanged={isExpDefinationChanged}
                      setIsScreenLoaded={setIsExperimentLoaded}
                      setSelectedSidePanelTab={setSelectedSidePanelTab}
                      setCanvasRefs={(stageRef) => (canvasStageRef.current = stageRef)}
                      canvasWidth={_calculateCanvasWidth()}
                    />
                  )}
                />
                <Route
                  path="/exp/:id"
                  render={(props) => (
                    <ExperimentRouteRenderer
                      canvasWidth={_calculateCanvasWidth()}
                      widthMainDiv={widthMainDiv}
                      changeHeader={changeHeader}
                      openedSideBars={openedSideBars}
                      panelsState={panelsState}
                      nodeMenuDetails={nodeMenuDetails}
                      setZoomInvocker={setZoomInvocker}
                      zoomInvocker={zoomInvocker}
                      BottomMenu={BottomMenuComponent()}
                      imageNowDetails={imageNowDetails}
                      setScoreViewRef={setScoreViewRef}
                      wellLables={GetWellsLabels()}
                      isLayerMode={isLayerMode}
                      expId={expid}
                      openedIconPanel={openedIconPanel}
                      isStateUpdated={isStateUpdated}
                      stateUpdated={stateUpdated}
                      isExpDefinationChanged={isExpDefinationChanged}
                      showLayers={showLayers}
                      changeShowLayers={changeShowLayersCanvas}
                      drawingLayerType={drawingLayerType}
                      reportType={reportType}
                      setReportType={setReportType}
                      updateRoute={updateRoute}
                      getOrignalLayers={getOrignalLayers}
                      setIsExperimentLoaded={setIsExperimentLoaded}
                      setCanvasRefs={(stageRef) => (canvasStageRef.current = stageRef)}
                      setSelectedSidePanelTab={setSelectedSidePanelTab}
                      isExperimentLoaded={isExperimentLoaded}
                      isImagedExperiment={getDefaultInspection(exp) ? true : false}
                      {...props}
                    />
                  )}
                />
              </Switch>
              {experimentHeaderPanelsContent && (
                //@ts-ignore
                <div
                  id="experiment-dashboard-side-panel-root"
                  style={styles.sidePanelRoot(sidePanelWidth)}
                >
                  {experimentHeaderPanelsContent}
                </div>
              )}
            </div>
          </div>
        </div>
      </DragContextProvider>

      {showOptimize && (
        <OptimizationWizard
          selectedWells={allWellNavigationDetails}
          setShow={setShowOptimize}
        />
      )}
      <SeedFormulation
        selectedWells={allWellNavigationDetails}
        show={showSeedFormulation}
        setShow={setShowSeedFormulation}
        isNew
      />

      {showReportDialogue && (
        <ExperimentReportsDialogue
          selectedWell={allWellNavigationDetails}
          reportType={reportType}
          setReportType={setReportType}
          canvasRef={canvasStageRef.current}
          docData={exp}
          platePadding={GetPlatePadding()}
          onPopupBlocked={() => {
            setPopupBlockedModal(true);
          }}
        />
      )}
      {popupBlockedModal &&
        showPopupBlockedModal(showModalSimple, setPopupBlockedModal, hideModal)}
      {awaitableModalContent}
    </ExpDashboardContext.Provider>
  );
}
// TODO: move style definition
const styles: any = {
  //@ts-ignore
  sidePanelRoot: (width: number) => ({
    position: 'fixed',
    display: 'block',
    width: `${width - 1}%`,
    height: '80.5%',
    top: '10.5%',
    left: `${101 - width}%`,
    right: 0,
    bottom: 0,
    borderLeft: '1px solid lightGray',
    backgroundColor: 'white',
  }),
};

/**
 * ModalContainer
 *
 * Keeps a buffered copy of `modalDetails` so the modal content
 * doesn’t change immediately while closing (prevents flicker).
 */
const ModalContainer: React.FC<{
  modalDetails: ModalDetails;
  setModalDetails(detail: ModalDetails): void;
  modalOkDisabled: boolean;
}> = ({ modalDetails, setModalDetails, modalOkDisabled }) => {
  const [content, setContent] = useState<ModalDetails>(modalDetails);
  // update content only when modal is opening
  useEffect(() => {
    if (modalDetails.showModal) {
      setContent(modalDetails);
    }
  }, [modalDetails]);

  return (
    <RMModal
      id="experiment-dashboard-modal-container"
      showModal={modalDetails.showModal}
      setShowModal={() => setModalDetails({ ...modalDetails, showModal: false })}
      onOk={content.onOk}
      body={content.body}
      heading={content.heading}
      okButtonText={content.okButtonText}
      dialogClassName={
        content.heading === 'Save Image' ? 'modal-fullw' : content.dialogClassName
      }
      okayDisabled={modalOkDisabled}
      noButtonText={content.noButtonText}
      icon={content.icon}
      titleClr={content.titleClr}
      isOkOnly={content.isOkOnly}
      isCancelOnly={content.isCancelOnly}
    />
  );
};

export default ExperimentDashboard;
